import { flowRight } from 'lodash';
import makeDataAccessHoc from './makeDataAccessHoc';
import propMapper from './propMapper';
import queryGql from './withCurrentUser.graphql';
const dataHoc = makeDataAccessHoc(queryGql, { fetchPolicy: 'cache-first' });
const mapperHoc = propMapper({
    me: currentUser => ({ currentUser }),
    systemConfig: systemConfig => ({ systemConfig }),
});
const withCurrentUser = (...params) => flowRight(dataHoc(...params), mapperHoc);
withCurrentUser.defaultProps = {
    currentUser: null,
    me: null,
    systemConfig: null,
};
export default withCurrentUser;
